import { Clear } from "@material-ui/icons";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import Button from "@mui/material/Button";
import { useEffect, useState } from "react";
import Moment from "react-moment";

import { downloadFileCommentMulti } from "../../api/Shared";
import {
  IFileData,
  NewIDataUploadItem,
} from "../../interfaces/IDataUploadItem";
import { getSharepointToken } from "../../pages/view-form/api-endpoint/callApi";
import UploadMultipleFileComponent from "../uploadmultiplefile/UploadMultipleFile";

export default function CommentDisabledComponent({
  allObj,
  key,
  onChildDownload,
}) {
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [dataUpload, setDataUpload] = useState<NewIDataUploadItem[]>([
    {
      title: "Bukti / Evidence",
      fileType: "Evidence",
      files: [{ documentID: "", fileBase64: "", fileName: "", folderName: "" }],
    },
  ]);
  const [sharepoint, setSharepoint] = useState<any>({ token: "", expToken: 0 });
  const [loadingActive, setLoadingActive] = useState(false);

  const handleChangeDownload = async (dataIndex, fileIndex) => {
    const getDataUpload = [...dataUpload];
    const downloadLink = document.createElement("a");

    // eslint-disable-next-line unicorn/consistent-function-scoping, consistent-return
    const downloadFile = async () => {
      try {
        // get all data for table list User
        const currentTime: any = new Date();
        const differenceInMinutesTokenSharepoint: any =
          (sharepoint.expToken - currentTime) / 1000 / 60;

        if (differenceInMinutesTokenSharepoint < 10) {
          const tokenSharepoint = await getSharepointToken();

          setSharepoint({
            ...sharepoint,
            token: tokenSharepoint.token,
            expToken: new Date(currentTime.getTime() + 30 * 60 * 1000),
          });
          // lakukan download
          const getBase64Download = await downloadFileCommentMulti({
            documentName: getDataUpload[dataIndex].files[fileIndex].fileName,
            commentID: allObj.commentID,
            sharepointToken: tokenSharepoint.token,
          });
          return getBase64Download;
        }
        // eslint-disable-next-line no-else-return
        else {
          const getBase64Download = await downloadFileCommentMulti({
            documentName: getDataUpload[dataIndex].files[fileIndex].fileName,
            commentID: allObj.commentID,
            sharepointToken: sharepoint.token,
          });
          return getBase64Download;
        }
      } catch (error) {
        console.log("Error fetching data:", error);
      }
    };

    setLoadingActive(true);
    const tempBase64File = await downloadFile();
    setLoadingActive(false);
    if (getDataUpload[dataIndex].files[fileIndex].documentID != "") {
      getDataUpload[dataIndex].files[fileIndex].fileBase64 = tempBase64File;
    }
    if (getDataUpload[dataIndex].files[fileIndex].fileBase64 != "") {
      downloadLink.href = getDataUpload[dataIndex].files[fileIndex].fileBase64;
      downloadLink.download =
        getDataUpload[dataIndex].files[fileIndex].fileName;
      downloadLink.click();
    }
  };

  useEffect(() => {
    const defaultData: IFileData[] = [];
    allObj.files.map((e) => {
      defaultData.push({
        documentID: e.documentID,
        fileName: e.documentName,
        folderName: e.link,
        fileBase64: "",
      });
    });
    setDataUpload([
      {
        title: "Bukti / Evidence",
        fileType: "Evidence",
        files: defaultData,
      },
    ]);
  }, []);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          marginY: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: { xs: "flex-start", sm: "space-between" },
            alignItems: "center",
            gap: 1,
            marginBottom: 1,
          }}
        >
          <Typography variant="subtitle1" style={{ marginTop: "0.55%" }}>
            <i>
              <Moment format="dddd,">{allObj.dateIn}</Moment>
            </i>{" "}
            <Moment format="MMMM DD, YYYY">{allObj.dateIn}</Moment>
          </Typography>
          {dataUpload[0].files.length > 0 && (
            <Button
              onClick={() => setOpenPreviewDialog(true)}
              style={{ textTransform: "none", color: "white" }}
              variant="contained"
            >
              <Typography variant="subtitle1">View</Typography>
            </Button>
          )}
        </Box>
        <div
          style={{
            padding: "10px 16px",
            backgroundColor: "#d6d6d6",
            borderRadius: 7,
            border: "1px solid gray",
            borderColor: "#9f9f9f",
            fontSize: "14px",
            color: "#858585",
          }}
        >
          <div>{allObj.comment}</div>
        </div>
      </Box>
      <Dialog open={openPreviewDialog} maxWidth={false}>
        <DialogTitle
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography>{allObj.evidence}</Typography>
          <Box
            display="flex"
            sx={{ cursor: "pointer" }}
            onClick={() => setOpenPreviewDialog(false)}
          >
            <Clear />
          </Box>
        </DialogTitle>
        <DialogContent style={{ padding: "1rem", paddingTop: 0 }}>
          {dataUpload.map((obj, i) => (
            <div
              style={{
                width: window.innerWidth * 0.35,
              }}
            >
              <UploadMultipleFileComponent
                disabled
                file={obj}
                fileIndex={i}
                onUploadFile={() => {}}
                onDeleteFile={() => {}}
                onDownloadFile={(fileIndex) => {
                  handleChangeDownload(i, fileIndex);
                }}
                onAddMoreData={() => {
                  if (dataUpload[i].files.length < 5) {
                    setDataUpload((prevState) => {
                      const newState = [...prevState];
                      const emptyFile = {
                        documentID: "",
                        fileBase64: "",
                        fileName: "",
                        folderName: "",
                      };
                      if (i >= 0 && i < newState.length) {
                        newState[i].files.push(emptyFile);
                      }

                      return newState;
                    });
                  }
                }}
                onDeleteData={() => {}}
                requiredValidationMessage=""
              />
            </div>
          ))}
        </DialogContent>
      </Dialog>
    </>
  );
}
